import React from 'react';

import Button from '@alliancesafetycouncil/asc-button';
import MainCard from '@alliancesafetycouncil/asc-card';

import { Logo } from '../../components/Logo/Logo';
import ProgressBar from '../../components/ProgressBar/ProgressBar';

const progress = { percent: "66%" }

const Match = () => {
  return (
    <div className="p-2 md:p-3">
      <div className="w-[175px] mt-6 mb-8 mx-auto">
        <Logo />
      </div>
      <div className="relative w-full md:w-9/12 lg:w-8/12 xl:w-7/12 mx-auto pb-10">
        <div className="absolute w-full">
          <ProgressBar progress={progress.percent} />
        </div>
        <MainCard type="main">
          <div className="grid grid-cols-1 gap-6">
            <div className="mt-6 text-2xl">Additional Information</div>
            <div className="text-xl">
              Is this you?
            </div>
            <div>
              <div className="text-lg font-medium">Tom Cook</div>
              <div>225-555-1212</div>
              <div>tcook@email.com</div>
              <div>iLevel Student ID: 938542</div>
            </div>
            <div className="flex flex-row">
              <div className="mr-3">
                <Button type="save" size="md" href="/#/confirmation">
                  Yes, It's Me
                </Button>
              </div>
              <div className="mr-3">
                <Button type="secondary" size="md" href="/#/form-other">
                  No, It's Not Me
                </Button>
              </div>
              <div>
                <Button type="tertiary" size="md" href="/#/form-phone">
                  Back
                </Button>
              </div>
            </div>
          </div>
        </MainCard>
      </div>
    </div>
  );
};

export default Match;
